import PageHeader from "../components/PageHeader";
import HireReactJSDeveloperContent from "../components/Hire-ReactJS-Developer-Content";

const HireReactJsDeveloper = () => {
    return (
        <>
            <PageHeader pagetitle="ReactJs Developer" breadcrumbMenu="Home" breadcrumbMenuActive="ReactJs Developer" image="/images/react-developers-banner.jpg" />
            <HireReactJSDeveloperContent />
        </>
    )
}

export default HireReactJsDeveloper;